module.exports = __webpack_public_path__ + "img/i_media_tracker-2.764940af.png";